"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fail = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/naming-convention */
const config_1 = tslib_1.__importStar(require("./config"));
const ok = 0;
const err = 1;
function success(_a) {
    var { ret, msg } = _a, others = tslib_1.__rest(_a, ["ret", "msg"]);
    return Object.assign({ code: ok, msg: msg || 'OK' }, others);
}
function fail(code, msg, data = '') {
    return {
        code: typeof code === 'string' ? err : 1,
        data,
        msg,
    };
}
exports.fail = fail;
/**
 * get请求
 * @param {string} url 请求url（如果url是相对地址，将与baseUrl拼接形成完整地址；如果rul是绝对地址，url直接作为完整地址）
 */
const get = (url) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield config_1.default(url);
        if (res.code === 200 || res.ret === 0) {
            return success(res || {});
        }
        return fail(res.code || res.statusCode, res.msg);
    }
    catch (e) {
        // 处理异常
        return fail('-1', e);
    }
});
/**
 * post请求
 * @param {string} url 请求url（如果url是相对地址，将与baseUrl拼接形成完整地址；如果rul是绝对地址，url直接作为完整地址）
 * @param {any} body
 */
const post = (url, body) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield config_1.default(url, {
            body,
            method: config_1.HttpMethod.post,
        });
        if (res.code === 200 || res.ret === 0) {
            return success(res || {});
        }
        return fail(res.code || res.statusCode, res.msg);
    }
    catch (e) {
        // 处理异常
        return fail('-1', e);
    }
});
exports.default = {
    get,
    post,
    getBaseUrl: config_1.getBaseUrl,
    setBaseUrl: config_1.setBaseUrl,
};
